<template>
  <v-data-table
    dense
    :headers="headers"
    :items="desserts"
    :search="search"
    sort-by="id"
    class="elevation-1"
  >
    <template v-slot:top>
      <v-toolbar flat color="white">
        <!-- <v-toolbar-title>Заказчики</v-toolbar-title> -->
        <!-- <v-divider class="mx-4" inset vertical></v-divider> -->
        <!-- <v-spacer></v-spacer> -->
      <v-text-field
        v-model="search"
        append-icon="search"
        clearable
        label="Поиск ..."
        single-line
        hide-details
      ></v-text-field>
        <v-spacer></v-spacer>
        <v-btn class="mb-2" @click="Add"><v-icon left>add</v-icon>Добавить заказчика</v-btn>
      </v-toolbar>
    </template>

    <template v-slot:item.active="{ item }">
      <template v-if="item.active">
          <v-chip x-small :color="getColor(item.active)" class="white--text">{{ getBool(item.active) }}</v-chip>
      </template>
      <template v-else>
          <v-chip x-small :color="getColor(item.active)">{{ getBool(item.active) }}</v-chip>
      </template>
    </template>
    <template v-slot:item.action="{ item }">
      <v-icon
        small
        class="mr-2"
        @click="editItem(item)"
      >
        edit
      </v-icon>
      <v-icon
        small
        @click="deleteItem(item)"
      >
        delete
      </v-icon>
    </template>

  </v-data-table>
</template>


<script>
  import Swal from "sweetalert2";
  export default {
    data: () => ({
      search: '',
      dialog: false,
      headers: [
          {
          text: "id",
          align: "left",
          sortable: false,
          value: "id"
        },
        {
          text: "Название",
          align: "left",
          sortable: false,
          value: "name"
        },
        { text: "Активен", value: "active" },
        { text: "Время ред.", value: "updated_at" },
        { text: "Действия", value: "action", sortable: false }
      ],
      //desserts: [],

    }),

    computed: {
      desserts() {
        return this.$store.getters.getCustomersCS;
      },

    },

    created () {
      //this.initialize()
    },

    methods: {
      getBool(val) {
        if(val) return "Да"
        else return "Нет"
      },
      getColor(color) {
        if(color) return "red";
        return "transparent";
      },

      Add() {
        this.$store
        .dispatch("addCustomerCS")
        .then(() => {
          this.$router.push({ name: "addcustomer" });
        })
        .catch(error => {
          alert(error);
        });
      },

      editItem (item) {
        const Arr = {
            id: item.id,
            name: item.name,
            active: item.active
        };
        this.$store
        .dispatch("getCustomerCS", Arr)
        .then(() => {
          this.$router.push({ name: "editcustomer" });
        })
        .catch(error => {
          alert(error);
        });

      },

      deleteItem (item) {
        Swal.fire({
          icon: "error",
          title: "Ошибка удаления",
          text: "Эта возможность пока еще не активирована"
        });
      },


    },

    mounted(){
      this.setTitle(`Заказчики`)
    }
  }
</script>
